import React from "react";

const SectionHeader = ({ eyebrow, title, lead, center }) => {
  return (
    <div style={{ textAlign: center ? "center" : "left", marginBottom: 28, maxWidth: center ? 760 : "none", marginLeft: center ? "auto" : 0, marginRight: center ? "auto" : 0 }}>
      {eyebrow && <span className="eyebrow">{eyebrow}</span>}
      {title && <h2 className="section-title">{title}</h2>}
      {lead && <p className="section-lead" style={center ? { marginLeft: "auto", marginRight: "auto" } : {}}>{lead}</p>}
    </div>
  );
};

export default SectionHeader;
